import {
  IPackagesService,
  PackagesPaginatedResponse,
} from './IPackagesService';
import {
  PackageService,
  InitWithAmplify,
  InitEnvironmentVariable,
} from '@PikaDoApp/npm-pikado-logic';
import type {
  NewPackage,
  NewCreatePackageInput,
  NewUpdatePackageInput,
  NewUpdatedPackage,
  NewPackageById,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/package/graphql/package.interface';
import {Amplify} from 'aws-amplify';
import {getEnvironment} from '../../lib/getEnvironment';

export class PackagesService implements IPackagesService {
  packageService: PackageService;

  constructor() {
    InitWithAmplify(Amplify);
    InitEnvironmentVariable(getEnvironment());
    this.packageService = new PackageService();
  }

  async getPackages(
    page: number = 1,
    limit: number = 20,
  ): Promise<PackagesPaginatedResponse> {
    try {
      const response = await this.packageService.newFindAllPackages(
        page,
        limit,
      );

      const packagesData = response.findAllPackages;

      return {
        items: packagesData.data || [],
        page: packagesData.page,
        totalPages: packagesData.totalPages,
        total: packagesData.total,
        limit: packagesData.limit,
      };
    } catch (error) {
      console.error('Error fetching packages:', error);
      throw error;
    }
  }

  async getPackageById(packageId: string): Promise<NewPackageById> {
    try {
      const response = await this.packageService.newFindPackageById(packageId);
      console.log("mhhr2 response-",response)
      return response.findPackageById;
    } catch (error) {
      console.error('Error fetching package by id:', error);
      throw error;
    }
  }

  async createPackage(input: NewCreatePackageInput): Promise<NewPackage> {
    try {
      console.log('Creating package with input:', input);
      const response = await this.packageService.newCreatePackage(input);
      return response.createPackage;
    } catch (error: any) {
      console.error('Error creating package:', JSON.stringify(error, null, 2));

      if (error.errors) {
        throw new Error(error.errors.map((e: any) => e.message).join(', '));
      }

      throw new Error(error.message || 'Unknown error creating package');
    }
  }

  async updatePackage(input: NewUpdatePackageInput): Promise<NewUpdatedPackage> {
    try {
      console.log('Updating package with input:', input);
      const response = await this.packageService.newUpdatePackage(input);
      return response.updatePackage;
    } catch (error: any) {
      console.error('Error updating package:', error);
      throw new Error(error.message || 'Unknown error updating package');
    }
  }

  async deletePackage(packageId: string): Promise<boolean> {
    try {
      console.log('Deleting package:', packageId);
      const response = await this.packageService.newDeletePackage(packageId);
      return response.deletePackage.isDeleted;
    } catch (error: any) {
      console.error('Error deleting package:', error);
      throw new Error(error.message || 'Unknown error deleting package');
    }
  }
}
